import FileSaver from "file-saver"
import { toast } from "react-toastify"

export default function exportCsv(csv: string, fileName: string) {
    const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    FileSaver.saveAs(csvData, fileName, true)
    toast.success("CSV file downloaded successfully.")
}
